export default [
  {
    path: "/payins",
    component: () => import(/* webpackChunkName: "payins" */ "./layout"),

    children: [
      {
        path: "/",
        name: "payins.index",
        component: () => import(/* webpackChunkName: "payins" */ "./index"),
      },
      {
        props: true,
        path: ":id",
        name: "payins.show",
        component: () => import(/* webpackChunkName: "payins" */ "./show"),
      },
    ],
  },
];
